/**
 * Zehnplus purchase option (blocks/zp-kaufart.liquid).
 * When the subscription is chosen:
 * - the large price, its unit price and the price in the sticky buy bar show the subscription price,
 * - the quantity options (blocks/zp-menge.liquid) are hidden and the quantity goes back to 1.
 * All prices come from data attributes rendered by Liquid; nothing is calculated here.
 */

/** @param {Element} fieldset - The .zp-kaufart element. */
function applyChoice(fieldset) {
  const section = fieldset.closest('.shopify-section');
  const checked = fieldset.querySelector('.zp-kaufart__input:checked');
  if (!section || !(checked instanceof HTMLInputElement)) return;

  const isSubscription = checked.value !== '';
  const { preis, grundpreis } = checked.dataset;

  if (preis) {
    for (const element of section.querySelectorAll(
      'product-price.zp-preis .price bdi, .sticky-add-to-cart__price .price bdi'
    )) {
      element.textContent = preis;
    }
  }

  if (grundpreis) {
    for (const element of section.querySelectorAll('product-price.zp-preis .unit-price bdi')) {
      element.textContent = grundpreis;
    }
  }

  const quantity = section.querySelector('[data-zp-menge]');
  if (quantity instanceof HTMLElement) {
    quantity.hidden = isSubscription;

    if (isSubscription) {
      const one = quantity.querySelector('input[value="1"]');
      if (one instanceof HTMLInputElement && !one.checked) {
        one.checked = true;
        one.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
}

document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLInputElement) || !target.classList.contains('zp-kaufart__input')) return;

  const fieldset = target.closest('.zp-kaufart');
  if (fieldset) applyChoice(fieldset);
});

// The browser may restore a chosen option when the visitor comes back to the page.
function applyAll() {
  for (const fieldset of document.querySelectorAll('.zp-kaufart')) applyChoice(fieldset);
}

window.addEventListener('pageshow', applyAll);
applyAll();
